export const OFFLINE_TRANSACTION_BOUNDARY = {
  id: "CV-2",
  mode: "offline_between_members",
  platformProcessesPayments: false,
  allowsInAppCheckout: false,
  platformRole:
    "Coptic Neighbor captures contact intent, request context, message history, reports, reviews, and response quality; members arrange pricing, contracts, scheduling, service delivery, and payment directly with each other.",
  prohibitedPlatformActions: [
    "collect_payment_card",
    "collect_bank_account",
    "collect_payment_credentials",
    "store_payment_method",
    "checkout_session",
    "escrow_payment",
    "platform_refund",
    "provider_subscription",
  ],
};

export const CONTACT_QUALITY_METRICS = [
  "contact_starts",
  "first_response_time",
  "reply_rate",
  "unanswered_contacts",
  "request_responses",
  "review_follow_through",
  "reported_threads",
];

const CARD_NUMBER_PATTERN = /(?:\b\d[ -]*?){13,19}\b/;
const CVV_PATTERN = /\b(?:cvv|cvc|security code)\s*(?:is|:)?\s*\d{3,4}\b/i;
const BANK_DETAIL_PATTERN =
  /\b(?:routing|account)\s*(?:number|#|is|:)?\s*\d{6,17}\b|\b\d{9}\s+(?:routing|aba)\b/i;

function compactText(value) {
  return String(value || "").replace(/\s+/g, " ").trim();
}

export function validateMessageForOfflineTransactionBoundary(message) {
  const text = compactText(message);
  const errors = [];

  if (CARD_NUMBER_PATTERN.test(text) || CVV_PATTERN.test(text)) {
    errors.push({
      code: "payment_card_detail",
      message: "Do not send card numbers, CVV codes, or payment credentials through Coptic Neighbor.",
    });
  }

  if (BANK_DETAIL_PATTERN.test(text)) {
    errors.push({
      code: "bank_account_detail",
      message: "Do not send bank account or routing details through Coptic Neighbor.",
    });
  }

  return errors;
}

export function buildTransactionBoundaryNotice(surface = "message") {
  if (surface === "request") {
    return "Your budget is context, not a checkout. Coptic Neighbor does not process payments; members and providers arrange pricing and payment directly after making contact.";
  }

  if (surface === "listing") {
    return "Price guidance is optional. Coptic Neighbor does not process payments, escrow funds, or guarantee provider work; members arrange payment directly with providers.";
  }

  return "Coptic Neighbor does not process payments. Arrange pricing, scheduling, and payment directly when you are comfortable, but do not send card, bank, or payment details in messages.";
}
